<template lang="pug">
    .component-card
        .row
            .columns.shrink.align-self-middle(v-if="showBullets", v-on:click="bulletsClicked")
                i.fa.fa-ellipsis-v.fa-2x
            .columns
                .row
                    .columns.shrink
                        slot(name="header_left")
                    .columns
                        slot(name="header")
                    .columns.shrink
                        slot(name="header_right")
                .row
                    .columns
                        slot
                .row
                    .columns.shrink
                        slot(name="footer_left")
                    .columns
                        slot(name="footer")
                    .columns.shrink
                        slot(name="footer_right")
            .columns.shrink.align-self-middle(v-if="showAction", v-on:click="actionClicked")
                i.fa.fa-angle-right.fa-3x.action
</template>
<script type="text/babel">
    export default{
        name: "Card",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {
            actionClicked(){
                this.$emit('actionClicked')
            },
            bulletsClicked(){
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// Card.vue?303f0821